<template>
    <div class="container-fluid">
        <div class="block-header">
            <bread-crumb></bread-crumb>
        </div>
        <div class="row clearfix justify-content-center">
            <div class="col-lg-8 col-md-10 col-sm-12">
                <div class="card card-top-line">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="body">
                                <ul class="list-unstyled mb-5 text-center">
                                    <li><h4>Lets's get ready to start your campaign!</h4></li>
                                    <li>
                                        <p>We want to create the best onboarding for you - please fill out the information below. 
                                            <strong>Your answers will be locked for this campaign and can't be changed later.</strong>
                                        </p>
                                    </li>
                                </ul>
                                <ul class="list-unstyled mb-0 row who-list">
                                    <li class="col-6 d-flex">
                                        <div class="who-box d-flex align-items-center flex-column justify-content-center flex-fill p-4 border cursor-pointer" @click="redirectCampaignDetails('Individual')">
                                            <div class="btn btn-primary">
                                                <div class="svg-box wh-30 ml-auto mr-auto">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                                                        <path class="st0" d="M50,2.5c26.2,0,47.5,21.3,47.5,47.5S76.2,97.5,50,97.5S2.5,76.2,2.5,50c0-12.6,5-24.7,13.9-33.6
                                                            S37.4,2.5,50,2.5z M40.6,57.6c0.2-1.7-4.8-8.1-5.7-11.2c-2-3.1-2.7-8.1-0.5-11.4c0.9-1.3,0.5-2.4,0.5-4.3c0-18,31.5-18,31.5,0
                                                            c0,2.3-0.5,2.8,0.7,4.6c2.1,3,1,8.3-0.8,11.1c-1.1,3.2-6.3,9.4-6,11.2C60.6,66.9,40.5,66.6,40.6,57.6L40.6,57.6L40.6,57.6z
                                                            M16.6,73.2c2.5-2.8,7-2.9,12.5-5.7c2.1-1,4.1-2.2,6-3.5c6.4,7.8,11.6,16.4,9.9,26.3c1.7,0.2,3.3,0.3,5,0.3c0.4,0,0.8,0,1.3,0
                                                            C50.9,78.9,57.7,70.3,65,63.1c3.7,2.5,7.7,4.5,12,5.9c3.6,1.2,5.7,2,7,3.3C96.3,53.6,91.1,28.4,72.4,16s-44-7.1-56.3,11.6
                                                            C7,41.5,7.2,59.5,16.6,73.2L16.6,73.2z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <h6 class="mb-0 mt-3">Individual</h6>
                                        </div>
                                    </li>
                                    <li class="col-6 d-flex">
                                        <div class="who-box d-flex align-items-center flex-column justify-content-center flex-fill p-4 border cursor-pointer" @click="redirectCampaignDetails('Non-Profit-Organisation')">
                                            <div class="btn btn-primary">
                                                <div class="svg-box wh-30 ml-auto mr-auto">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                                                        <g>
                                                            <path d="M2.5,17.7c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7v60.4h81c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7H2.5L2.5,17.7
                                                                L2.5,17.7z"/>
                                                            <path d="M78.2,34.8h9.7c0.6,0,1,0.5,1,1v38.1c0,0.6-0.5,1-1,1h-9.7c-0.6,0-1-0.5-1-1v-38C77.1,35.3,77.6,34.8,78.2,34.8z"/>
                                                            <path d="M59,34.8h9.7c0.6,0,1,0.7,1,1.5v37.1c0,0.8-0.5,1.5-1,1.5H59c-0.6,0-1-0.7-1-1.5V36.3C58,35.6,58.5,34.8,59,34.8z"/>
                                                            <path d="M39.9,34.8h9.7c0.6,0,1,0.5,1,1l0,0v38.1c0,0.6-0.5,1-1,1h-9.7c-0.6,0-1-0.5-1-1v-38C38.9,35.3,39.4,34.8,39.9,34.8z"/>
                                                            <path d="M20.8,34.9h9.7c0.6,0,1,0.7,1,1.7l0,0v36.8c0,0.9-0.5,1.6-1,1.7h-9.7c-0.6,0-1-0.7-1-1.7V36.7
                                                                C19.8,35.7,20.3,34.9,20.8,34.9L20.8,34.9z"/>
                                                            <polygon points="22.6,24.2 63,24.2 63,29.8 84.9,21.2 63,12.4 63,18.1 22.6,18.1 	"/>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>
                                            <h6 class="mb-0 mt-3">Not for Profit</h6>
                                            <h6 class="mb-0 mt-0">Organisation</h6>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "@/plugins/vee-validate";
export default {
    name:'CampaignTypeComponent',
    components: {
        BreadCrumb: () => import('@/components/BreadCrumb.vue'),
    },methods:{
        redirectCampaignDetails(campaign_for){
            this.$router.push({name:'campaign-details', params:{ type: this.$route.params.type, campaign_for: campaign_for }});
        }
    }
}
</script>
